module.exports = __webpack_public_path__ + "img/puck-dimensions-v01.f20302c1.png";